/**
 * Shared helpers for the document/photo upload dialogs (prescriptions, foot scans,
 * existing-supply documents). Centralises the accepted MIME set so the `accept`
 * attribute and the client-side validation stay in sync across components.
 */

/**
 * MIME types accepted by the document/image upload flows.
 */
export const IMAGE_UPLOAD_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'] as const

/**
 * Value for a file input's `accept` attribute covering the standard image+PDF upload set.
 */
export const IMAGE_UPLOAD_ACCEPT = 'image/jpeg,image/jpg,image/png,application/pdf'

/**
 * True if `file` is an accepted upload type for the given allow-list.
 */
export function isAcceptedUploadFile(file: File, allowedMimeTypes: readonly string[] = IMAGE_UPLOAD_MIME_TYPES): boolean {
  return allowedMimeTypes.includes(file.type)
}

/**
 * Obergrenze fuer eine einzelne Datei in genau diesen Upload-Wegen. Spiegelt
 * `DocumentScannerService.MAX_RAW_UPLOAD_BYTES` im Backend: darueber lehnt der Server ab, ohne
 * ueberhaupt zu komprimieren. Bis 2026-10-01 stand hier in vier Komponenten 10 MB, Dateien
 * zwischen 8 und 10 MB liefen also erst nach dem Upload in die Ablehnung. Aendert sich die Zahl im
 * Backend, gehoeren diese Konstante, die Hinweistexte der vier Upload-Komponenten und der Text zu
 * `ATTACHMENT_TOO_LARGE` in den Interceptoren mit.
 */
export const UPLOAD_MAX_BYTES = 8 * 1024 * 1024
